import { gql } from '@apollo/client';

export interface CreateSupportLoginShortCodeResponse {
    createSupportLoginShortCode: {
        success: boolean;
        message?: string | null;
        shortCode?: string | null;
        phone?: number | null;
    };
}

export interface CreateSupportLoginShortCodeVariables {
    targetAccountPhone: number;
}

export const CREATE_SUPPORT_LOGIN_SHORT_CODE = gql`
    mutation CreateSupportLoginShortCode($targetAccountPhone: Long!) {
        createSupportLoginShortCode(targetAccountPhone: $targetAccountPhone) {
            success
            message
            shortCode
            phone
        }
    }
`;
